export default __webpack_public_path__ + "static/media/59.187d8a73.png";